// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ important

  // ✅ Restore auth safely
  useEffect(() => {
    try {
      const stored = localStorage.getItem("auth");

      if (stored) {
        const data = JSON.parse(stored);

        setUser(data.user || null);
        setRole(data.role || null);
        setPermissions(data.permissions || []);
      }
    } catch (err) {
      console.error("Invalid auth data");
      localStorage.removeItem("auth"); // cleanup
    } finally {
      setLoading(false); // ✅ done loading
    }
  }, []);

  // ✅ Login
  const login = (data) => {
    const authData = {
      user: data.user || null,
      role: data.role || null,
      permissions: data.permissions || [],
    };

    setUser(authData.user);
    setRole(authData.role);
    setPermissions(authData.permissions);

    localStorage.setItem("auth", JSON.stringify(authData));
  };

  // ✅ Logout
  const logout = () => {
    setUser(null);
    setRole(null);
    setPermissions([]);
    localStorage.removeItem("auth");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        role,
        permissions,
        login,
        logout,
        loading, // ✅ expose loading
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);